import { Action } from 'redux';
import { GlobalDataStateStructure, URL_PARAM_REFERRAL_TYPE } from '../interfaces/globalStateStructure.interface';
import { URLParams } from '../../interfaces/url-params.interface';


const INITIAL_STATE: GlobalDataStateStructure = {
  urlParams: {
    opportunityId: '',
    customerId: '',
    agentCode: '',
    agencyNumber: '',
    referralid: '',
    linkShareToken: ''
  },
  findMemberId: '',
  referralType: null

};

const SAVE_REFERRAL_TYPE = 'SAVE_REFERRAL_TYPE'
const SAVE_URL_PARAMS = 'SAVE_URL_PARAMS';
const INIT_URL_PARAMS = 'INIT_URL_PARAMS';
const PERSIST_GLOBAL_DATA = 'PERSIST_GLOBAL_DATA';
const SAVE_MEMBER_ID = 'SAVE_MEMBER_ID';

export class WorkerAppAction implements Action {
  type: string;
  urlParams: URLParams;
  globalData: GlobalDataStateStructure;
  findMemberId?: string;
  referralType?: URL_PARAM_REFERRAL_TYPE;
}

export function saveUrlParams(urlParameter: URLParams) {
  return {
    type: SAVE_URL_PARAMS,
    urlParams: urlParameter
  };
}

export function persistGlobalData(globalInfo: GlobalDataStateStructure) {
  return {
    type: PERSIST_GLOBAL_DATA,
    globalData: globalInfo
  };
}

export function saveMemberID(uniqueMemberId: string) {
  return{
    type: SAVE_MEMBER_ID,
    findMemberId: uniqueMemberId
  };
}

export function saveReferralType(typeReferral: URL_PARAM_REFERRAL_TYPE){
  return{
    type: SAVE_REFERRAL_TYPE,
    referralType: typeReferral
  }
}
/**
 * Worker reducers
 */
export const GLOBAL_DATA_REDUCER_NAME = 'GlobalData';
export function GlobalData(
    state: GlobalDataStateStructure = INITIAL_STATE,
    action: WorkerAppAction
  ) {
  const copiedState: GlobalDataStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case SAVE_URL_PARAMS:

      if (action.urlParams.opportunityId) {
        copiedState.urlParams.opportunityId = action.urlParams.opportunityId;
      }
      if (action.urlParams.customerId) {
        copiedState.urlParams.customerId = action.urlParams.customerId;
      }
      if (action.urlParams.agentCode) {
        copiedState.urlParams.agentCode = action.urlParams.agentCode;
      }
      if (action.urlParams.agencyNumber) {
        copiedState.urlParams.agencyNumber = action.urlParams.agencyNumber;
      }
      if (action.urlParams.referralid) {
        copiedState.urlParams.referralid = action.urlParams.referralid;
      }
      if (action.urlParams.opportunityId) {
        copiedState.urlParams.opportunityId = action.urlParams.opportunityId;
      }
      if (action.urlParams.crmOpportunityId) {
        copiedState.urlParams.crmOpportunityId = action.urlParams.crmOpportunityId;
      }

      /** Marketplace Query Params */
      if (action.urlParams['P1']) {
        copiedState.urlParams['P1'] = action.urlParams['P1'];
      }
      if (action.urlParams['P2']) {
        copiedState.urlParams['P2'] = action.urlParams['P2'];
      }
      if (action.urlParams['P3']) {
        copiedState.urlParams['P3'] = action.urlParams['P3'];
      }
      if (action.urlParams['P4']) {
        copiedState.urlParams['P4'] = action.urlParams['P4'];
      }
      if (action.urlParams['P5']) {
        copiedState.urlParams['P5'] = action.urlParams['P5'];
      }
      if (action.urlParams['P6']) {
        copiedState.urlParams['P6'] = action.urlParams['P6'];
      }
      if (action.urlParams['P7']) {
        copiedState.urlParams['P7'] = action.urlParams['P7'];
      }

      if (action.urlParams['linkShareToken']) {
        copiedState.urlParams['linkShareToken'] = action.urlParams['linkShareToken'].split('#!/')[0];
      }
      return Object.assign({}, state, copiedState);
    case INIT_URL_PARAMS:
    case PERSIST_GLOBAL_DATA:
      return Object.assign({}, state, action.globalData);
    case SAVE_MEMBER_ID:
      copiedState.findMemberId = action.findMemberId;
      return Object.assign({}, state, copiedState);
    case SAVE_REFERRAL_TYPE:
      copiedState.referralType = action.referralType;
      return Object.assign({}, state, copiedState);
    default:
      return state;
  }
}
